import React from 'react';
import { SelectedCategories } from './types';
import { getIntl } from '../../../utils/intl';
import Stack from '../Stack';
import Text from '../Text';
import { SEARCH_FILTER_HEIGHT } from './SearchFilters';

const intl = getIntl('SelectedCategoriesDisplay', {
    selected: 'Selected',
});

export type SelectedCategoriesDisplayOwnProps = {
    selectedCategories: SelectedCategories;
};

export type SelectedCategoriesDisplayProps = SelectedCategoriesDisplayOwnProps;

const SelectedCategoriesDisplay: React.FC<SelectedCategoriesDisplayProps> = ({ selectedCategories }) => {
    if (!selectedCategories.length) return null;

    const displayed = selectedCategories.filter((_) => _.count);
    if (!displayed.length) return null;

    const sorted = displayed.sort((a, b) => a.label.localeCompare(b.label));

    return (
        <Stack fullHeight vertical justify="flex-start">
            <Stack vertical justify="center" style={{ height: SEARCH_FILTER_HEIGHT }}>
                <Stack horizontal space={2} testID="selected-category-display">
                    <Text variant="bold-body-1">{intl('selected')}:</Text>
                    <Text variant="body-1">
                        {sorted.map((category) => `${category.count} ${category.label}`).join(', ')}
                    </Text>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default React.memo(SelectedCategoriesDisplay);
